module.exports = __webpack_public_path__ + "img/dynamic_banner.6ee5a1d7.jpg";